import React from 'react';
import './Wrapper.css';

export interface Props {
  children?: React.ReactNode
}

export default function Wrapper(props: Props) {
  return (
    <div className="Wrapper">
      {props.children}
    </div>
  );
}
